import { BCMSCurrency } from "@bcm-dev/bcms-vite";
import { SVGAsset } from "res";
import "./styles.css";

export default function BottomPaymentInfo(props) {

    const description = props.description ?? "";
    let amount = "[$XX.XX]";
    const date = props.date ?? "[MM/DD/YY]";
    const status = props.status == undefined
        ? "[STATUS]"
        : props.status.charAt(0).toUpperCase() + props.status.slice(1);
    const showAutopay = props.showAutopay ?? false;

    // "Upcoming bills" in "Pay Bills" uses this component
    // but shows "Bill" info, not "Payment" info. No "Payment"
    // will be passed to this component in that case.
    const payment = props.payment ?? {};
    const paymentID = payment.id ? ("_" + payment.id) : "";

    // START: Set data points.
    const amountDataPoint = props.dataPoint ? { "data-point" : props.dataPoint + "_Amount" + paymentID } : {};
    const statusDataPoint = props.dataPoint ? { "data-point" : props.dataPoint + "_Status" + paymentID } : {};
     const descDataPoint = props.dataPoint ? { "data-point" : props.dataPoint + "_Description" + paymentID } : {};
    // END: Set data points.

    // type of promps.amount determines value of amount
    if(props.amount instanceof BCMSCurrency) {
        amount = props.amount.format();
    } else if(props.amount instanceof String) {
        amount = props.amount;
    }

    return (
        <div className="bottom-payment-info">
          <p className="sub-text gray-text">
            <span {...descDataPoint}>
                { description } { props.recurring }<span>{ status }</span> <b><span>{ date }</span></b> for <b><span className="amount" { ...amountDataPoint }>{ amount }</span></b>{ showAutopay && <SVGAsset id="TwoArrowsIcon" className="icon" /> }
            </span>
          </p> 
        </div>
    );
  }